import { createFileRoute } from "@tanstack/react-router";
import { BillingOverviewPage } from "../../features/billing/overview-page";

export const Route = createFileRoute("/billing/")({ component: BillingOverviewPage });
